// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "id.plumaa",
    name: "Plumaa ID",
    homepage: "https://plumaa.id",
    image_id: "dd6271ac-f9ba-4580-4db2-484bf4d0fc00",
    app: {
        browser: "https://app.plumaa.id",
        ios: "https://apps.apple.com/mx/app/plumaa-id/id6475269207",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "plumaa://",
        universal: "https://api.plumaa.id/app/",
    },
    desktop: {
        native: "plumaa://",
        universal: "https://api.plumaa.id/app/",
    },
};
//# sourceMappingURL=index.js.map